import * as Model from "./MODEL";

export import MODEL = Model;
